import { useGetChatTopics as useGetChatTopicsQuery } from '~/hooks/apis/support/useChatTopics';

export function useGetChatTopics() {
  const { data: chatTopics = [], isLoading: loading } = useGetChatTopicsQuery();

  return {
    loading,
    chatTopics,
  };
}
